module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buenzen_AG-23533669c0a9e5f362dbf87a067894f6.svg";